import React, { useState } from 'react';
import { useGetApplicationsQuery } from '../../../../../../../../redux/services/ApplicationsApi';
import { statusesTranslate } from '../../statuses';
import { FilterValues } from '../../../CustomFilterModal/CustomFilterModal';

interface Props { filter?: FilterValues | null}

const ApplicationsBlocks: React.FC<Props> = ({ filter }) => {
    const [searchId, setSearchId] = useState('');
    const { data, error, isLoading } = useGetApplicationsQuery(
    undefined,
    { pollingInterval: 10000 }
  );
  if (isLoading) {
    return <div>Загрузка заявок...</div>;
  }
  if (error) {
    return <div>Ошибка загрузки заявок</div>;
  }
  if (!data || data.length === 0) {
    return <div className="no-data-icon">Нет заявок для отображения</div>;
  }

  const GROUP_STATUS_CODES: Record<string, string[]> = {
    new:           ['BN'],
    in_progress:   ['IP'],
    dispute:       ['ID'],
    success:       ['SF', 'AA', 'AAD'],
    recalculations:['UR', 'FR', 'CR'],
    errors:        ['NF', 'TO'],
    canceled_grp:  ['CANCELED'],
    support:       ['STS', 'STSD', 'PC'],
};

// Применяем наш фильтр
    let filtered = data;
    if (filter) {
        if (filter.type !== 'all') {
            filtered = filtered.filter(app => app.type === filter.type);
        }
        if (filter.status !== 'all') {
            filtered = filtered.filter(app => GROUP_STATUS_CODES[filter.status].includes(app.status));
        }
        if (filter.amountFrom !== '') {
            filtered = filtered.filter(app => app.final_amount >= filter.amountFrom);
        }
        if (filter.amountTo !== '') {
            filtered = filtered.filter(app => app.final_amount <= filter.amountTo);
        }
        if (filter.dateFrom) {
            filtered = filtered.filter(app => new Date(app.date) >= new Date(filter.dateFrom));
        }
        if (filter.dateTo) {
            filtered = filtered.filter(app => new Date(app.date) <= new Date(filter.dateTo));
        }
    }
  const filteredData = searchId
     ? filtered.filter(app => app.id.includes(searchId))
     : filtered;
  return (
    <div>
      {filteredData.map((app) => (
        <div key={app.id} className="application-block">
          <div><strong>UID:</strong> {app.id}</div>
          <div><strong>Дата:</strong> {new Date(app.date).toLocaleString()}</div>
          <div>
            <strong>Тип:</strong> {app.type === 'deposit' ? 'Пополнение' : 'Выплата'}
          </div>
          <div><strong>Курс:</strong> {app.course}</div>
          <div><strong>Сумма:</strong> {app.final_amount}</div>
          <div><strong>Статус:</strong> {statusesTranslate[app.status] ?? app.status}</div>
        </div>
      ))}
    </div>
  );
};

export default ApplicationsBlocks;
